import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'

export default class extends BaseModule {
  init() {
    this.id = this.el.dataset.fragment
    this.modal = document.querySelector(`[data-fragment-modal="${this.id}"]`)
    this.el.addEventListener('mouseenter', this.open.bind(this))
    this.el.addEventListener('mouseleave', this.close.bind(this))
  }

  open() {
    gsap.to(this.modal, {
      autoAlpha: 1,
      duration: 0.5,
      ease: 'power2.inOut',
    })
  }

    close() {
    gsap.to(this.modal, {autoAlpha: 0,duration: 0.5,ease: 'power2.inOut',})
    }


}
